<template>
  <div class="page-wrapper">
    <div class="page-container">
      <!-- Breadcrumb and Header -->
      <div class="page-header">
        <div class="flex justify-between items-center flex-wrap gap-4">
          <div class="breadcrumb">
            <span class="crumb-link" @click="$router.push('/')">Asosiy</span>
            <span class="separator">/</span>
            <span class="crumb-current">Faoliyat jurnali (Audit & IP/MAC)</span>
          </div>

          <div class="flex items-center gap-3">
            <button 
              class="btn-refresh" 
              :class="{ 'spinning': loading }" 
              @click="loadAllData" 
              title="Yangilash"
            >
              <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
                <path d="M21.5 2v6h-6M21.34 15.57a10 10 0 1 1-.57-8.38l5.67-5.67"/>
              </svg>
              Yangilash
            </button>
            <div class="live-indicator">
              <span class="pulse-dot"></span>
              Real vaqt rejimi
            </div>
          </div>
        </div>
      </div>

      <!-- Stat Cards -->
      <div class="summary-cards mt-4">
        <!-- Bugungi kirishlar -->
        <div class="summary-card card-blue">
          <div class="card-content">
            <h2 class="card-value">{{ stats.todayLogins || 0 }}</h2>
            <p class="card-label">Bugungi kirishlar</p>
          </div>
          <div class="card-icon">
            <svg xmlns="http://www.w3.org/2000/svg" width="28" height="28" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
              <path d="M15 3h4a2 2 0 0 1 2 2v14a2 2 0 0 1-2 2h-4"/>
              <polyline points="10 17 15 12 10 7"/>
              <line x1="15" y1="12" x2="3" y2="12"/>
            </svg>
          </div>
        </div>

        <!-- Hozir onlayn -->
        <div class="summary-card card-green">
          <div class="card-content">
            <div class="flex items-center gap-2">
              <h2 class="card-value">{{ stats.onlineUsers || 0 }}</h2>
              <span class="online-badge-pulse"></span>
            </div>
            <p class="card-label">Hozir tizimda faol (Onlayn)</p>
          </div>
          <div class="card-icon">
            <svg xmlns="http://www.w3.org/2000/svg" width="28" height="28" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
              <path d="M17 21v-2a4 4 0 0 0-4-4H5a4 4 0 0 0-4 4v2"/>
              <circle cx="9" cy="7" r="4"/>
              <path d="M23 21v-2a4 4 0 0 0-3-3.87"/>
              <path d="M16 3.13a4 4 0 0 1 0 7.75"/>
            </svg>
          </div>
        </div>

        <!-- Bugungi o'zgartirishlar -->
        <div class="summary-card card-purple">
          <div class="card-content">
            <h2 class="card-value">{{ stats.todayChanges || 0 }}</h2>
            <p class="card-label">Bugungi o'zgartirishlar</p>
          </div>
          <div class="card-icon">
            <svg xmlns="http://www.w3.org/2000/svg" width="28" height="28" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
              <path d="M11 4H4a2 2 0 0 0-2 2v14a2 2 0 0 0 2 2h14a2 2 0 0 0 2-2v-7"/>
              <path d="M18.5 2.5a2.121 2.121 0 0 1 3 3L12 15l-4 1 1-4 9.5-9.5z"/>
            </svg>
          </div>
        </div>

        <!-- Unikal IP manzillar -->
        <div class="summary-card card-amber">
          <div class="card-content">
            <h2 class="card-value">{{ stats.uniqueIpsCount || 0 }}</h2>
            <p class="card-label">Faol IP manzillar</p>
          </div>
          <div class="card-icon">
            <svg xmlns="http://www.w3.org/2000/svg" width="28" height="28" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
              <circle cx="12" cy="12" r="10"/>
              <line x1="2" y1="12" x2="22" y2="12"/>
              <path d="M12 2a15.3 15.3 0 0 1 4 10 15.3 15.3 0 0 1-4 10 15.3 15.3 0 0 1-4-10 15.3 15.3 0 0 1 4-10z"/>
            </svg>
          </div>
        </div>
      </div>

      <!-- Tab Buttons -->
      <div class="tabs-container mt-6">
        <button 
          class="tab-btn" 
          :class="{ 'tab-active': activeTab === 'sessions' }"
          @click="changeTab('sessions')"
        >
          <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
            <rect x="2" y="3" width="20" height="14" rx="2" ry="2"/>
            <line x1="8" y1="21" x2="16" y2="21"/>
            <line x1="12" y1="17" x2="12" y2="21"/>
          </svg>
          Tizimga kirishlar va Seanslar (IP & MAC)
        </button>

        <button 
          class="tab-btn" 
          :class="{ 'tab-active': activeTab === 'actions' }"
          @click="changeTab('actions')"
        >
          <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
            <polyline points="22 12 18 12 15 21 9 3 6 12 2 12"/>
          </svg>
          O'zgartirishlar va Harakatlar tarixi (Audit)
        </button>
      </div>

      <!-- Filters Row -->
      <div class="filters-row mt-4">
        <!-- Search box -->
        <div class="search-box">
          <input 
            type="text" 
            v-model="filters.search" 
            placeholder="F.I.Sh, IP yoki MAC bo'yicha qidirish..." 
            class="search-input"
            @keyup.enter="applyFilters"
          />
          <button class="search-btn" @click="applyFilters">
            <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><circle cx="11" cy="11" r="8"/><line x1="21" y1="21" x2="16.65" y2="16.65"/></svg>
          </button>
        </div>

        <!-- Role filter -->
        <select v-model="filters.role" class="filter-select ml-3" @change="applyFilters">
          <option value="">Barcha rollar</option>
          <option value="Super Admin">Super Admin</option>
          <option value="Kafedra mudiri">Kafedra mudiri</option>
          <option value="Dekan">Dekan</option>
          <option value="prorektor">Prorektor</option>
          <option value="O'qituvchi">O'qituvchi</option>
        </select>

        <!-- Action Type filter (only in actions tab) -->
        <select 
          v-if="activeTab === 'actions'" 
          v-model="filters.actionType" 
          class="filter-select ml-3" 
          @change="applyFilters"
        >
          <option value="">Barcha amallar</option>
          <option value="STATUS_CHANGE">Shaxsiy reja tasdiqlash/rad etish</option>
          <option value="TAQSIMOT_CHANGE">Soatlar taqsimoti</option>
          <option value="YUKLAMA_CHANGE">Kafedra yuklamalari</option>
          <option value="DELETE">O'chirish amallari</option>
          <option value="LOGIN">Tizimga kirishlar</option>
          <option value="LOGOUT">Tizimdan chiqishlar</option>
        </select>

        <!-- Status filter (only in sessions tab) -->
        <select 
          v-if="activeTab === 'sessions'" 
          v-model="filters.status" 
          class="filter-select ml-3" 
          @change="applyFilters"
        >
          <option value="all">Barcha seanslar</option>
          <option value="online">Faqat onlaynlar</option>
          <option value="offline">Chiqib ketganlar</option>
        </select>

        <!-- Period filter -->
        <select v-model="filters.period" class="filter-select ml-3" @change="applyFilters">
          <option value="all">Barcha vaqt</option>
          <option value="today">Bugun</option>
          <option value="yesterday">Kecha</option>
          <option value="week">Oxirgi 7 kun</option>
          <option value="month">Oxirgi 30 kun</option>
        </select>

        <button class="btn-clear ml-3" @click="resetFilters">
          <svg xmlns="http://www.w3.org/2000/svg" width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><line x1="18" y1="6" x2="6" y2="18"/><line x1="6" y1="6" x2="18" y2="18"/></svg>
          Filtrni tozalash
        </button>
      </div>

      <!-- Table Card -->
      <div class="table-card mt-4">
        <div v-if="loading" class="text-center py-12 text-gray-500">
          <div class="inline-block animate-spin rounded-full h-8 w-8 border-b-2 border-blue-600 mb-2"></div>
          <div>Ma'lumotlar yuklanmoqda...</div>
        </div>

        <!-- TAB 1: SESSIONS TABLE -->
        <div v-else-if="activeTab === 'sessions'" class="table-responsive">
          <table class="main-table">
            <thead>
              <tr>
                <th class="w-12 text-center">#</th>
                <th class="text-left">F.I.Sh / Foydalanuvchi</th>
                <th class="text-center">Roli</th>
                <th class="text-center">IP manzil</th>
                <th class="text-center">MAC manzil</th>
                <th class="text-left">Qurilma / Brauzer</th>
                <th class="text-center">Kirgan vaqti</th>
                <th class="text-center">Oxirgi faollik</th>
                <th class="text-center">Ishlagan vaqti</th>
                <th class="text-center">Holati</th>
              </tr>
            </thead>
            <tbody>
              <tr v-if="sessions.length === 0">
                <td colspan="10" class="text-center py-10 text-gray-500">
                  Birorta ham kirish seansi topilmadi
                </td>
              </tr>
              <tr v-for="(item, idx) in sessions" :key="item._id || idx">
                <td class="text-center text-gray-400 font-mono">
                  {{ (pagination.page - 1) * pagination.limit + idx + 1 }}
                </td>
                <td>
                  <div class="user-cell">
                    <div class="user-avatar">{{ getInitials(item.userName) }}</div>
                    <div>
                      <div class="font-semibold text-slate-800">{{ item.userName }}</div>
                      <div class="text-xs text-gray-400" v-if="item.userPhone">{{ item.userPhone }}</div>
                    </div>
                  </div>
                </td>
                <td class="text-center">
                  <span class="role-badge" :class="getRoleClass(item.userRole)">{{ item.userRole || 'Foydalanuvchi' }}</span>
                </td>
                <td class="text-center">
                  <span class="ip-tag">{{ item.ipAddress || '—' }}</span>
                </td>
                <td class="text-center">
                  <span class="mac-tag">{{ item.macAddress || '—' }}</span>
                </td>
                <td>
                  <div class="text-xs text-slate-700 font-medium">{{ item.deviceInfo || '—' }}</div>
                </td>
                <td class="text-center text-xs font-mono text-slate-600">
                  {{ formatDateTime(item.loginTime || item.createdAt) }}
                </td>
                <td class="text-center text-xs font-mono text-slate-600">
                  {{ formatDateTime(item.lastActiveTime) }}
                </td>
                <td class="text-center">
                  <span class="duration-badge">{{ item.sessionDuration || '1 daqiqa' }}</span>
                </td>
                <td class="text-center">
                  <span v-if="item.isOnline" class="status-online">
                    <span class="dot-green"></span> Onlayn
                  </span>
                  <span v-else class="status-offline">
                    Chiqqan
                  </span>
                </td>
              </tr>
            </tbody>
          </table>
        </div>

        <!-- TAB 2: AUDIT LOGS TABLE -->
        <div v-else-if="activeTab === 'actions'" class="table-responsive">
          <table class="main-table">
            <thead>
              <tr>
                <th class="w-12 text-center">#</th>
                <th class="text-center">Amal turi</th>
                <th class="text-left">Foydalanuvchi</th>
                <th class="text-center">IP / MAC</th>
                <th class="text-left">Qilingan amal va tafsilotlar</th>
                <th class="text-center">Sana va soat</th>
              </tr>
            </thead>
            <tbody>
              <tr v-if="logs.length === 0">
                <td colspan="6" class="text-center py-10 text-gray-500">
                  Birorta ham o'zgartirish jurnali topilmadi
                </td>
              </tr>
              <tr v-for="(item, idx) in logs" :key="item._id || idx">
                <td class="text-center text-gray-400 font-mono">
                  {{ (pagination.page - 1) * pagination.limit + idx + 1 }}
                </td>
                <td class="text-center">
                  <span class="action-badge" :class="getActionBadgeClass(item.actionType)">
                    {{ getActionLabel(item.actionType) }}
                  </span>
                </td>
                <td>
                  <div class="font-semibold text-slate-800">
                    {{ (!item.userName || item.userName === 'Foydalanuvchi') ? (item.userPhone || item.userRole || 'Foydalanuvchi') : item.userName }}
                  </div>
                  <div class="text-xs text-gray-500 flex items-center gap-1">
                    <span class="role-badge-sm">{{ item.userRole }}</span>
                    <span v-if="item.userPhone">({{ item.userPhone }})</span>
                  </div>
                </td>
                <td class="text-center">
                  <div class="ip-tag mb-1">{{ item.ipAddress || '—' }}</div>
                  <div class="mac-tag-sm">{{ item.macAddress || '—' }}</div>
                </td>
                <td>
                  <div class="font-semibold text-sm text-slate-800">{{ item.actionTitle }}</div>
                  <div class="text-xs text-slate-600 mt-1 bg-slate-50 p-2 rounded border border-slate-200">
                    {{ item.details || 'Tafsilotlar mavjud emas' }}
                  </div>
                </td>
                <td class="text-center text-xs font-mono text-slate-600 whitespace-nowrap">
                  {{ formatDateTime(item.createdAt) }}
                </td>
              </tr>
            </tbody>
          </table>
        </div>

        <!-- Pagination Footer -->
        <div class="pagination-footer mt-4" v-if="pagination.total > 0">
          <div class="text-sm text-slate-500">
            Jami: <strong class="text-slate-800">{{ pagination.total }}</strong> ta yozuv ({{ pagination.page }}-sahifa)
          </div>

          <div class="flex items-center gap-2" v-if="pagination.totalPages > 1">
            <button 
              class="page-btn" 
              :disabled="pagination.page <= 1"
              @click="goToPage(pagination.page - 1)"
            >
              Oldingi
            </button>
            <span class="page-current">{{ pagination.page }} / {{ pagination.totalPages }}</span>
            <button 
              class="page-btn" 
              :disabled="pagination.page >= pagination.totalPages"
              @click="goToPage(pagination.page + 1)"
            >
              Keyingi
            </button>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import axios from "axios";

const API = process.env.VUE_APP_API_URL;

export default {
  name: "FaoliyatJurnali",
  data() {
    return {
      activeTab: "sessions", // sessions | actions
      loading: false,
      sessions: [],
      logs: [],
      stats: {
        todayLogins: 0,
        onlineUsers: 0,
        todayChanges: 0,
        uniqueIpsCount: 0,
      },
      filters: {
        search: "",
        role: "",
        actionType: "",
        status: "all",
        period: "all",
      },
      pagination: {
        page: 1,
        limit: 50,
        total: 0,
        totalPages: 1,
      },
      autoRefreshInterval: null,
    };
  },
  async created() {
    await this.loadAllData();
    // Auto refresh every 30 seconds
    this.autoRefreshInterval = setInterval(() => {
      this.loadAllData(false);
    }, 30000);
  },
  beforeUnmount() {
    if (this.autoRefreshInterval) {
      clearInterval(this.autoRefreshInterval);
    }
  },
  methods: {
    async loadAllData(showLoader = true) {
      if (showLoader) this.loading = true;
      try {
        await Promise.all([
          this.fetchStats(),
          this.activeTab === "sessions" ? this.fetchSessions() : this.fetchLogs(),
        ]);
      } catch (err) {
        console.error("Error loading audit data:", err);
      } finally {
        if (showLoader) this.loading = false;
      }
    },
    async fetchStats() {
      try {
        const token = localStorage.getItem("token");
        const res = await axios.get(`${API}/audit-logs/stats`, {
          headers: { Authorization: `Bearer ${token}` },
        });
        if (res.data.success) {
          this.stats = res.data.data;
        }
      } catch (e) {}
    },
    async fetchSessions() {
      try {
        const token = localStorage.getItem("token");
        const res = await axios.get(`${API}/audit-logs/sessions`, {
          headers: { Authorization: `Bearer ${token}` },
          params: {
            page: this.pagination.page,
            limit: this.pagination.limit,
            search: this.filters.search,
            status: this.filters.status,
          },
        });
        if (res.data.success) {
          this.sessions = res.data.data.items || [];
          this.pagination = { ...this.pagination, ...res.data.data.pagination };
        }
      } catch (e) {
        console.error("Error fetching sessions:", e);
      }
    },
    async fetchLogs() {
      try {
        const token = localStorage.getItem("token");
        const res = await axios.get(`${API}/audit-logs`, {
          headers: { Authorization: `Bearer ${token}` },
          params: {
            page: this.pagination.page,
            limit: this.pagination.limit,
            search: this.filters.search,
            actionType: this.filters.actionType,
            role: this.filters.role,
            period: this.filters.period,
          },
        });
        if (res.data.success) {
          this.logs = res.data.data.items || [];
          this.pagination = { ...this.pagination, ...res.data.data.pagination };
        }
      } catch (e) {
        console.error("Error fetching logs:", e);
      }
    },
    changeTab(tabName) {
      this.activeTab = tabName;
      this.pagination.page = 1;
      this.loadAllData();
    },
    applyFilters() {
      this.pagination.page = 1;
      this.loadAllData();
    },
    resetFilters() {
      this.filters = {
        search: "",
        role: "",
        actionType: "",
        status: "all",
        period: "all",
      };
      this.pagination.page = 1;
      this.loadAllData();
    },
    goToPage(pageNum) {
      if (pageNum < 1 || pageNum > this.pagination.totalPages) return;
      this.pagination.page = pageNum;
      this.loadAllData();
    },
    getInitials(name) {
      if (!name) return "U";
      const parts = name.trim().split(" ");
      if (parts.length >= 2) {
        return (parts[0][0] + parts[1][0]).toUpperCase();
      }
      return name.slice(0, 2).toUpperCase();
    },
    formatDateTime(dateStr) {
      if (!dateStr) return "—";
      const d = new Date(dateStr);
      if (isNaN(d.getTime())) return "—";
      const y = d.getFullYear();
      const m = String(d.getMonth() + 1).padStart(2, "0");
      const day = String(d.getDate()).padStart(2, "0");
      const h = String(d.getHours()).padStart(2, "0");
      const min = String(d.getMinutes()).padStart(2, "0");
      const s = String(d.getSeconds()).padStart(2, "0");
      return `${day}.${m}.${y} ${h}:${min}:${s}`;
    },
    getRoleClass(role) {
      const r = String(role || "").toLowerCase();
      if (r.includes("super")) return "role-super";
      if (r.includes("kafedra") || r.includes("mudir")) return "role-kafedra";
      if (r.includes("dekan")) return "role-dekan";
      if (r.includes("prorektor")) return "role-prorektor";
      return "role-teacher";
    },
    getActionLabel(type) {
      switch (type) {
        case "LOGIN": return "Tizimga kirish";
        case "LOGOUT": return "Tizimdan chiqish";
        case "STATUS_CHANGE": return "Holat o'zgardi";
        case "TAQSIMOT_CHANGE": return "Soat taqsimoti";
        case "YUKLAMA_CHANGE": return "Yuklama o'zgardi";
        case "DELETE": return "O'chirish";
        case "CREATE": return "Qo'shish";
        default: return "Boshqa amal";
      }
    },
    getActionBadgeClass(type) {
      switch (type) {
        case "LOGIN": return "act-login";
        case "LOGOUT": return "act-logout";
        case "STATUS_CHANGE": return "act-status";
        case "TAQSIMOT_CHANGE": return "act-taqsimot";
        case "DELETE": return "act-delete";
        default: return "act-default";
      }
    },
  },
};
</script>

<style scoped>
.page-wrapper {
  background-color: #f8fafc;
  min-height: calc(100vh - 64px);
}

.page-container {
  max-width: 100%;
  margin: 0 auto;
}

.page-header {
  background: white;
  padding: 16px 24px;
  border-bottom: 1px solid #e2e8f0;
  margin: -16px -16px 16px -16px;
}

@media (min-width: 1024px) {
  .page-header {
    margin: -24px -24px 24px -24px;
  }
}

.breadcrumb {
  font-size: 14px;
  color: #64748b;
  display: flex;
  align-items: center;
  gap: 8px;
}

.crumb-link {
  cursor: pointer;
  color: #3b82f6;
  transition: color 0.2s;
}
.crumb-link:hover {
  text-decoration: underline;
  color: #2563eb;
}

.separator {
  color: #cbd5e1;
}

.crumb-current {
  color: #1e293b;
  font-weight: 600;
}

.btn-refresh {
  display: flex;
  align-items: center;
  gap: 6px;
  background: white;
  border: 1px solid #cbd5e1;
  border-radius: 6px;
  padding: 6px 14px;
  font-size: 13px;
  font-weight: 500;
  color: #334155;
  cursor: pointer;
  transition: all 0.2s;
}
.btn-refresh:hover {
  background: #f1f5f9;
  border-color: #94a3b8;
}
.btn-refresh.spinning svg {
  animation: spin 1s linear infinite;
}

@keyframes spin {
  from { transform: rotate(0deg); }
  to { transform: rotate(360deg); }
}

.live-indicator {
  display: flex;
  align-items: center;
  gap: 6px;
  background: #ecfdf5;
  color: #065f46;
  padding: 4px 10px;
  border-radius: 20px;
  font-size: 12px;
  font-weight: 600;
  border: 1px solid #a7f3d0;
}

.pulse-dot {
  width: 8px;
  height: 8px;
  border-radius: 50%;
  background-color: #10b981;
  box-shadow: 0 0 0 rgba(16, 185, 129, 0.4);
  animation: pulse-ring 1.5s infinite;
}

@keyframes pulse-ring {
  0% {
    box-shadow: 0 0 0 0 rgba(16, 185, 129, 0.7);
  }
  70% {
    box-shadow: 0 0 0 8px rgba(16, 185, 129, 0);
  }
  100% {
    box-shadow: 0 0 0 0 rgba(16, 185, 129, 0);
  }
}

/* Stat Cards */
.summary-cards {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(220px, 1fr));
  gap: 16px;
  margin-bottom: 20px;
}

.summary-card {
  border-radius: 10px;
  padding: 20px;
  display: flex;
  justify-content: space-between;
  align-items: center;
  color: white;
  box-shadow: 0 4px 6px -1px rgba(0, 0, 0, 0.08);
  transition: transform 0.2s ease, box-shadow 0.2s ease;
}
.summary-card:hover {
  transform: translateY(-2px);
  box-shadow: 0 8px 15px -3px rgba(0, 0, 0, 0.12);
}

.card-value {
  font-size: 32px;
  font-weight: 700;
  line-height: 1;
  margin: 0 0 8px 0;
}

.card-label {
  font-size: 13px;
  font-weight: 500;
  margin: 0;
  opacity: 0.95;
}

.card-icon {
  opacity: 0.85;
}

.card-blue {
  background: linear-gradient(135deg, #2563eb 0%, #1d4ed8 100%);
}
.card-green {
  background: linear-gradient(135deg, #059669 0%, #047857 100%);
}
.card-purple {
  background: linear-gradient(135deg, #7c3aed 0%, #6d28d9 100%);
}
.card-amber {
  background: linear-gradient(135deg, #d97706 0%, #b45309 100%);
}

.online-badge-pulse {
  display: inline-block;
  width: 10px;
  height: 10px;
  border-radius: 50%;
  background-color: #34d399;
  box-shadow: 0 0 8px #34d399;
}

/* Tabs */
.tabs-container {
  display: flex;
  gap: 10px;
  border-bottom: 2px solid #e2e8f0;
  padding-bottom: 2px;
}

.tab-btn {
  display: flex;
  align-items: center;
  gap: 8px;
  background: none;
  border: none;
  padding: 10px 18px;
  font-size: 14px;
  font-weight: 600;
  color: #64748b;
  cursor: pointer;
  border-radius: 8px 8px 0 0;
  transition: all 0.2s;
  position: relative;
}

.tab-btn:hover {
  color: #1e293b;
  background-color: #f1f5f9;
}

.tab-btn.tab-active {
  color: #2563eb;
  background-color: white;
  border-bottom: 3px solid #2563eb;
  margin-bottom: -2px;
}

/* Filters Row */
.filters-row {
  display: flex;
  align-items: center;
  flex-wrap: wrap;
  gap: 10px;
  background: white;
  padding: 16px;
  border-radius: 8px;
  box-shadow: 0 1px 3px 0 rgba(0, 0, 0, 0.05);
}

.search-box {
  display: flex;
  min-width: 280px;
  flex: 1;
}

.search-input {
  width: 100%;
  height: 40px;
  border: 1px solid #cbd5e1;
  border-radius: 6px 0 0 6px;
  padding: 0 14px;
  font-size: 13px;
  outline: none;
}
.search-input:focus {
  border-color: #3b82f6;
}

.search-btn {
  height: 40px;
  width: 44px;
  background-color: #1e293b;
  color: white;
  border: none;
  border-radius: 0 6px 6px 0;
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
}

.filter-select {
  height: 40px;
  border: 1px solid #cbd5e1;
  border-radius: 6px;
  padding: 0 12px;
  font-size: 13px;
  color: #334155;
  background: white;
  outline: none;
}

.btn-clear {
  display: flex;
  align-items: center;
  gap: 6px;
  height: 40px;
  padding: 0 14px;
  background: white;
  border: 1px solid #f87171;
  color: #ef4444;
  border-radius: 6px;
  font-size: 13px;
  font-weight: 500;
  cursor: pointer;
}
.btn-clear:hover {
  background: #fef2f2;
}

/* Table Card */
.table-card {
  background: white;
  border-radius: 8px;
  box-shadow: 0 1px 3px 0 rgba(0, 0, 0, 0.08);
  padding: 20px;
  overflow: hidden;
}

.table-responsive {
  overflow-x: auto;
}

.main-table {
  width: 100%;
  border-collapse: collapse;
  font-size: 13px;
}

.main-table th {
  background-color: #f8fafc;
  color: #475569;
  font-weight: 600;
  padding: 12px 14px;
  border-bottom: 2px solid #e2e8f0;
}

.main-table td {
  padding: 12px 14px;
  border-bottom: 1px solid #f1f5f9;
  vertical-align: middle;
}

.main-table tbody tr:hover {
  background-color: #f8fafc;
}

/* Badges & Tags */
.user-cell {
  display: flex;
  align-items: center;
  gap: 10px;
}

.user-avatar {
  width: 34px;
  height: 34px;
  border-radius: 50%;
  background: #3b82f6;
  color: white;
  font-weight: 700;
  font-size: 12px;
  display: flex;
  align-items: center;
  justify-content: center;
  flex-shrink: 0;
}

.role-badge {
  display: inline-block;
  padding: 3px 8px;
  border-radius: 4px;
  font-size: 11px;
  font-weight: 600;
}
.role-super { background: #fef3c7; color: #92400e; }
.role-kafedra { background: #ede9fe; color: #6b21a8; }
.role-dekan { background: #cffafe; color: #0e7490; }
.role-prorektor { background: #dcfce7; color: #166534; }
.role-teacher { background: #e0e7ff; color: #3730a3; }

.role-badge-sm {
  background: #f1f5f9;
  color: #475569;
  padding: 1px 6px;
  border-radius: 3px;
  font-weight: 600;
  font-size: 10px;
}

.ip-tag {
  display: inline-block;
  background: #f1f5f9;
  color: #0f172a;
  padding: 2px 8px;
  border-radius: 4px;
  font-family: monospace;
  font-size: 12px;
  font-weight: 600;
  border: 1px solid #e2e8f0;
}

.mac-tag {
  display: inline-block;
  background: #fefce8;
  color: #854d0e;
  padding: 2px 8px;
  border-radius: 4px;
  font-family: monospace;
  font-size: 12px;
  font-weight: 600;
  border: 1px solid #fef08a;
}

.mac-tag-sm {
  font-family: monospace;
  font-size: 11px;
  color: #854d0e;
}

.duration-badge {
  display: inline-block;
  background: #f8fafc;
  color: #334155;
  padding: 3px 8px;
  border-radius: 12px;
  font-size: 11px;
  font-weight: 600;
  border: 1px solid #cbd5e1;
}

.status-online {
  display: inline-flex;
  align-items: center;
  gap: 6px;
  background: #ecfdf5;
  color: #047857;
  padding: 3px 10px;
  border-radius: 12px;
  font-size: 11px;
  font-weight: 600;
}

.dot-green {
  width: 6px;
  height: 6px;
  border-radius: 50%;
  background-color: #10b981;
}

.status-offline {
  display: inline-block;
  background: #f1f5f9;
  color: #64748b;
  padding: 3px 10px;
  border-radius: 12px;
  font-size: 11px;
  font-weight: 500;
}

/* Action Badges */
.action-badge {
  display: inline-block;
  padding: 3px 10px;
  border-radius: 4px;
  font-size: 11px;
  font-weight: 600;
}
.act-login { background: #dbeafe; color: #1e40af; }
.act-logout { background: #f1f5f9; color: #64748b; }
.act-status { background: #dcfce7; color: #15803d; }
.act-taqsimot { background: #fae8ff; color: #86198f; }
.act-delete { background: #fee2e2; color: #b91c1c; }
.act-default { background: #e2e8f0; color: #334155; }

/* Pagination Footer */
.pagination-footer {
  display: flex;
  justify-content: space-between;
  align-items: center;
  flex-wrap: wrap;
  gap: 12px;
}

.page-btn {
  background: white;
  border: 1px solid #cbd5e1;
  border-radius: 4px;
  padding: 5px 12px;
  font-size: 12px;
  cursor: pointer;
}
.page-btn:disabled {
  opacity: 0.5;
  cursor: not-allowed;
}

.page-current {
  font-size: 12px;
  font-weight: 600;
  color: #334155;
}
</style>
